import React from 'react';
import styled from 'styled-components';

const SpacerStyled = styled.div({
  flexGrow: 9999,
});

type SpacerProps = {
  className?: string;
};

const Spacer = ({ className }: SpacerProps) => (
  <SpacerStyled className={className} />
);

export default Spacer;
